import React from 'react'
import { Moment } from 'moment'
import { PickersDay, PickersDayProps } from '@mui/x-date-pickers/PickersDay'

import { color } from 'styles/colors'

type DayProps = PickersDayProps<Moment> & {
  selectedStart: Moment | null
  selectedEnd: Moment | null
  isSelectingStart: boolean
  hoveredDate: Moment | null
  onDateSelectCallback: (date: Moment) => void
}

const Day = ({
  selectedStart,
  selectedEnd,
  isSelectingStart,
  hoveredDate,
  onDateSelectCallback,
  day,
  ...other
}: DayProps) => {
  const hasRange = selectedStart && selectedEnd
  const rangeStart = hasRange && selectedStart
  const rangeEnd = hasRange && selectedEnd

  const isInRange = hasRange && day.isSameOrAfter(rangeStart, 'day') && day.isSameOrBefore(rangeEnd, 'day')
  const isRangeStart = hasRange && day.isSame(rangeStart, 'day')
  const isRangeEnd = hasRange && day.isSame(rangeEnd, 'day')

  const isStartDate = selectedStart && day.isSame(selectedStart, 'day')

  const isInHoverRange = !isSelectingStart && selectedStart && hoveredDate && day.isSameOrAfter(selectedStart, 'day') && day.isSameOrBefore(hoveredDate, 'day')
  const isHoverStart = !isSelectingStart && selectedStart && day.isSame(selectedStart, 'day')
  const isHoverEnd = !isSelectingStart && hoveredDate && day.isSame(hoveredDate, 'day')

  const boundaryBase = { backgroundColor: color('dateRangeDayBoundary'), color: color('paneBackground') }
  const rangeHoverStyle = { '&:hover': { backgroundColor: color('dateRangeDayBackgroundHover') } }
  const boundaryHoverStyle = { '&:hover': { backgroundColor: color('dateRangeDayBoundaryHover') } }

  return (
    <PickersDay
      {...other}
      day={day}
        onMouseDown={() => onDateSelectCallback(day)}
      sx={{
        ...(isInRange && {
          backgroundColor: color('dateRangeDayBackground'),
          ...rangeHoverStyle
        }),
        ...(isInHoverRange && {
          backgroundColor: color('dateRangeDayBackground'),
          opacity: 0.7,
          ...rangeHoverStyle
        }),
        ...((isRangeStart || isRangeEnd || isStartDate) && {
          ...boundaryBase,
          ...boundaryHoverStyle,
          '&.Mui-selected': {
            backgroundColor: color('dateRangeDayBoundary')
          }
        }),
        ...((isHoverStart || isHoverEnd) && {
          ...boundaryBase,
          '&:hover': {
            backgroundColor: color('dateRangeDayBoundary')
          }
        })
      }}
    />
  )
}

export default Day
